import { render, staticRenderFns } from "./contractmanagement.vue?vue&type=template&id=15579fc1&scoped=true"
import script from "./contractmanagement.vue?vue&type=script&lang=js"
export * from "./contractmanagement.vue?vue&type=script&lang=js"
import style0 from "./contractmanagement.vue?vue&type=style&index=0&id=15579fc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15579fc1",
  null
  
)

export default component.exports